"use client";

import { useUserStore } from "@/stores/useAuthStore";


export function usePlaybackHref(targetHref: string): string {
  const isLoggedIn = useUserStore((s) => s.isLoggedIn);
  if (!targetHref) return targetHref;
  if (isLoggedIn) return targetHref;
  return `/login?returnTo=${encodeURIComponent(targetHref)}`;
}
